import ISO6391 from 'iso-639-1'

interface Expanded {
  country: string
  lang: string
  locale: string
}

const expand = (locale: string): Expanded => {
  const [lang, country] = locale.split('_')
  return { locale, lang, country }
}

const hasLangPart = ({ lang }: { lang: string }) => !lang.startsWith('_')

const isKnownLang = ({ lang }: { lang: string }) => !!ISO6391.getNativeName(lang)

const toNativeByLocale =
  (expanded: Expanded[]) =>
  (acc: Record<string, string>, { locale, lang, country }: Expanded) => {
    const isUnique = (l: string) => expanded.filter(x => x.lang === l).length === 1

    const native = ISO6391.getNativeName(lang) + (country && !isUnique(lang) ? ` (${country})` : '')
    return { ...acc, [locale]: native }
  }

export const nativeLanguageByLocale = (locales: string[]): Record<string, string> => {
  const expanded = locales.map(expand).filter(e => hasLangPart(e) && isKnownLang(e))
  return expanded.reduce(toNativeByLocale(expanded), {})
}
